import React from "react";
import { CreateMultiContainer } from "./ContainerMultiCreate";
import { getTracksOneYearAgo, getTracksTwoYearsAgo, getTracksThreeYearsAgo } from "../api/getTracks";
import Skeleton from "react-loading-skeleton";

class TracksOnThisDayContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const oneYearAgo = (data && data[0] && data[0].data.tracks) || [];
    const twoYearsAgo = (data && data[1] && data[1].data.tracks) || [];
    const threeYearsAgo = (data && data[2] && data[2].data.tracks) || [];

    if (loading) {
      return <Skeleton count={3} />;
    }
    return render({ oneYearAgo, twoYearsAgo, threeYearsAgo, loading, failure });
  };
}

export default CreateMultiContainer([getTracksOneYearAgo, getTracksTwoYearsAgo, getTracksThreeYearsAgo], TracksOnThisDayContainer);
